/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 25/7/2023
 */
import BaseObject from "@shared/BaseObject.js";

export default class SimpleRecurrenceItem extends BaseObject {

	intervalCount: number = 1
	intervalLength: string = "week"


	constructor() {
		super();
	}
}
